import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { ServerUrlService } from '../services/server-url.service'

@Injectable()
export class SystemTokenInterceptor implements HttpInterceptor {
  constructor(private serverUrl: ServerUrlService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const baseUrl = this.serverUrl.url
    if (!baseUrl || !request.url.startsWith(baseUrl)) {
      return next.handle(request)
    }

    const isExcluded =
      request.url.includes('/system/keys') ||
      request.url.includes('/tools/auth/token/decrypt') ||
      request.url.includes('/report-models/token/decrypt')
    const token = localStorage.getItem('integration_token')
    const name = localStorage.getItem('integration_sys')

    if (token && name && !isExcluded) {
      const authReq = request.clone({
        setHeaders: {
          token,
          sistema: name,
        },
      })
      return next.handle(authReq)
    }

    return next.handle(request)
  }
}
